import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "../services/adminApi";
import Pagination from "../components/Pagination";

const defaultFilter = { q: "", role: "", isActive: "" };

export default function Users() {
  const navigate = useNavigate();
  const [filters, setFilters] = useState(defaultFilter);
  const [data, setData] = useState({
    items: [],
    total: 0,
    page: 1,
    pageSize: 10,
  });
  const [error, setError] = useState("");

  const loadUsers = useCallback(async () => {
    try {
      const next = await adminApi.getUsers({
        page: data.page,
        pageSize: data.pageSize,
        ...filters,
      });
      setData(next);
      setError("");
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to load users");
    }
  }, [data.page, data.pageSize, filters]);

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  useEffect(() => {
    setData((prev) => (prev.page === 1 ? prev : { ...prev, page: 1 }));
  }, [filters.q, filters.role, filters.isActive]);

  const patchStatus = async (userId, isActive) => {
    await adminApi.updateUserStatus(userId, isActive);
    await loadUsers();
  };

  const patchRole = async (userId, role) => {
    await adminApi.updateUserRole(userId, role);
    await loadUsers();
  };

  const doWalletAction = async (userId, action) => {
    const amount = Number(prompt("Amount"));
    const reason = prompt("Reason") || "Manual admin action";
    if (!Number.isFinite(amount) || amount <= 0) return;
    if (action === "credit")
      await adminApi.creditWallet(userId, amount, reason);
    else await adminApi.debitWallet(userId, amount, reason);
    await loadUsers();
  };

  return (
    <div>
      <h2>User Management</h2>
      <div className="row" style={{ marginBottom: 12 }}>
        <input
          placeholder="Search by email, name, referral, or 6-digit user ID"
          value={filters.q}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, q: e.target.value }))
          }
        />
        <select
          value={filters.role}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, role: e.target.value }))
          }
        >
          <option value="">All Roles</option>
          <option value="user">user</option>
          <option value="admin">admin</option>
        </select>
        <select
          value={filters.isActive}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, isActive: e.target.value }))
          }
        >
          <option value="">All Status</option>
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>
        <button className="btn-primary" onClick={loadUsers}>
          Apply
        </button>
      </div>

      {error ? <div className="error">{error}</div> : null}

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>User ID</th>
                <th>Email</th>
                <th>Name</th>
                <th>Role</th>
                <th>Status</th>
                <th>2FA</th>
                <th>Wallet</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((user) => (
                <tr key={user.id}>
                  <td>
                    <span className="mono">{user.userNumber || "—"}</span>
                  </td>
                  <td>{user.email}</td>
                  <td>{user.name}</td>
                  <td>{user.role}</td>
                  <td>{user.isActive ? "active" : "inactive"}</td>
                  <td>{user.twoFAEnabled ? "enabled" : "disabled"}</td>
                  <td>{(user.wallet?.balance || 0).toFixed(2)}</td>
                  <td>
                    <div className="row">
                    <button
                      onClick={() => navigate(`/users/${user.id}`, { state: { openEdit: true } })}
                    >
                      Edit
                    </button>
                      <button
                        onClick={() => patchStatus(user.id, !user.isActive)}
                      >
                        {user.isActive ? "Disable" : "Enable"}
                      </button>
                      {/* <button
                        onClick={() => patchRole(user.id, user.role === "admin" ? "user" : "admin")}
                      >
                        Toggle Role
                      </button> */}
                      <button onClick={() => doWalletAction(user.id, "credit")}>
                        Credit
                      </button>
                      <button onClick={() => doWalletAction(user.id, "debit")}>
                        Debit
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          page={data.page}
          pageSize={data.pageSize}
          total={data.total}
          onPageChange={(nextPage) =>
            setData((prev) => ({
              ...prev,
              page: nextPage,
            }))
          }
        />
      </div>
    </div>
  );
}
